var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pointer archive-button button-item-handler white--text no-decoration description hideSmartphone",
    on: {
      "click": _vm.openClientFinancingOffer
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "print",
      "size": 18
    }
  }), _vm._v(" ponuka ")], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }